export default __webpack_public_path__ + "static/media/yen.dab88e36.svg";